<template>
    <section class="doctors-list bg-white" id="doctors">
        <div class="container">
            <h2 class="doctors-list__title">Врачи</h2>
            <div class="doctors-list__top">
                <div class="doctors-list__subtitle" v-html="subtitle"></div>
                <div class="doctors-list__navigation" v-if="showControls">
                    <button @click="prev" class="prev" :disabled="swiperProgress <= 0"></button>
                    <button @click="next" class="next" :disabled="swiperProgress >= 1"></button>
                </div>
            </div>
            <div class="doctors-list__carousel">
                <div v-swiper:swiper="swiperOptions" @slide-change="onSlideChange">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(doctor, index) in doctors" :key="index">
                            <div class="doctors-list__item">
                                <div class="doctors-list__item-image swiper-lazy" :data-background="doctor.image"></div>
                                <div class="doctors-list__item-name">{{ doctor.name }}</div>
                                <div class="doctors-list__item-desc">{{ doctor.desc }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {directive} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css'

export default {
    name: 'DoctorsList',
    props: {
        doctors: {
            type: Array,
            default: () => [],
        },
        subtitle: {
            type: String,
            default: () => '',
        },
    },
    data() {
        return {
            swiperOptions: {
                lazy: true,
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                        autoHeight: true,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                    1025: {
                        slidesPerView: 4,
                        spaceBetween: 57,
                    },
                },
            },
            swiperProgress: 0,
            showControls: false,
        }
    },
    methods: {
        prev() {
            this.swiper.slidePrev();
        },
        next() {
            this.swiper.slideNext();

        },
        onSlideChange() {
            this.swiperProgress = this.swiper.progress;
        },
    },
    directives: {
        swiper: directive,
    },
    mounted() {
        if (this.doctors.length > this.swiperOptions.breakpoints[this.swiper.currentBreakpoint].slidesPerView) {
            this.showControls = true;
        }
    },
}
</script>
<style lang="scss">
@import "../../scss/base/include";

.doctors-list {
    @include mobile {
        position: relative;
        padding-bottom: 63px;
    }

    &__title {
        @include tablet {
            font-size: 18px;
            line-height: 22px;
        }
        @include mobile {
            font-size: 24px;
            line-height: 120%;
            margin-bottom: 8px;
        }
    }

    &__top {
        position: relative;
        @include mobile {
            position: static;
        }
    }

    &__navigation {
        position: absolute;
        bottom: 0;
        right: 0;
        @include mobile {
            right: 24px;
        }

        button {
            background-color: transparent;
            width: 39px;
            height: 39px;
            background-image: url(/local/templates/pnd/src/assets/i/arrow.svg);
            background-position: 58% 50%;
            background-repeat: no-repeat;
            background-size: 9px auto;
            border: solid 1px $list-bullet;
            outline: none;
            border-radius: 50%;
            cursor: pointer;

            &:disabled {
                cursor: default;
                opacity: 0.3;
                border-color: $border;
            }

            &.prev {
                transform: scale(-1, 1);
            }

            &.next {
                margin-left: 8px;
            }
        }
    }

    &__subtitle {
        max-width: 740px;
        font-size: 18px;
        line-height: 27px;
        font-weight: normal;
        color: $gray;
        @include tablet {
            max-width: 502px;
            font-size: 16px;
            line-height: 24px;
        }
    }

    &__carousel {
        margin-top: 52px;
        margin-bottom: 22px;
        @include tablet {
            margin-top: 33px;
            margin-bottom: 0;
        }
    }

    &__item {
        @include tablet {
            max-width: 260px;
        }
        @include mobile {
            max-width: 100%;
            text-align: center;
        }

        &-image {
            @include size(220px, 222px);
            border-radius: 50%;
            margin-bottom: 43px;
            background-position: center;
            background-size: cover;
            @include tablet {
                @include size(172px, 174px);
                margin-bottom: 25px;
            }
            @include mobile {
                @include size(220px, 222px);
                margin: 0 auto 24px;
            }
        }

        &-name {
            margin-bottom: 9px;
            font-size: 18px;
            line-height: 21px;
            font-weight: normal;
            min-height: 42px;
            @include tablet {
                font-size: 16px;
                min-height: 38px;
                line-height: 19px;
            }
            @include mobile {
                min-height: 0;
            }
        }

        &-desc {
            font-size: 16px;
            line-height: 23px;
            font-weight: 300;
            font-family: 'HelveticaNeue';
            color: $gray;
            @include tablet {
                font-size: 14px;
                line-height: 142.9%;
                max-width: 260px;
            }
            @include mobile {
                margin: 0 auto;
            }
        }
    }
}
</style>
